"use client";

import { useEffect } from "react";
import type { BrandConfig } from "@/types/ai";

interface Props {
  brand: BrandConfig;
}

/**
 * Applies brand colors as CSS variables to the document
 */
export default function BrandStyles({ brand }: Props) {
  useEffect(() => {
    const root = document.documentElement;
    const body = document.body;
    
    // Set CSS variables for brand colors
    root.style.setProperty("--brand-primary", brand.primaryColor);
    root.style.setProperty("--brand-secondary", brand.secondaryColor);
    root.style.setProperty("--brand-text", brand.textColor || "#ffffff");
    root.style.setProperty("--brand-text-secondary", brand.textSecondaryColor || "rgba(255, 255, 255, 0.7)");
    
    // Apply custom font if specified
    if (brand.customFont) {
      body.style.fontFamily = brand.customFont;
    } else {
      body.style.fontFamily = "";
    }
    
    return () => {
      // Cleanup on unmount
      root.style.removeProperty("--brand-primary");
      root.style.removeProperty("--brand-secondary");
      root.style.removeProperty("--brand-text");
      root.style.removeProperty("--brand-text-secondary");
      body.style.fontFamily = "";
    };
  }, [brand]);

  return null;
}

